// extracted by mini-css-extract-plugin
module.exports = {"listdetail":"ListDetailItem_listdetail__2aeXl","listdetail__item":"ListDetailItem_listdetail__item__1DqsI","listdetail__item--bold":"ListDetailItem_listdetail__item--bold__3YxFm"};